module.exports = __webpack_public_path__ + "static/media/visitors.f6a91eff.svg";